var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',{staticClass:"load-progress-bar-container"},[_c('div',{staticClass:"border"},[_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.loadMsg))]),_vm._v(" "),_c('div',{staticClass:"progress",style:(_vm.styleProgress)})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }